export default {
  state: {
    data: false,
  },
  getters: {
    //
  },
  actions: {
    resetClick(context) {
      context.commit("updateClick", false)
    },
  },
  mutations: {
    updateClick(state, data) {
      return state.data = data
    }
  }
}